export default __webpack_public_path__ + "static/media/friction_lab.731d2328.gif";